var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKpIsAndProgramsManagement(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27 32H31V36H27V32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M34 32H38V36H34V32Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M27 25H31V29H27V25Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M34 25H38V29H34V25Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 32H12V18H36V23H38V18C37.9995 17.4697 37.7886 16.9613 37.4136 16.5864C37.0387 16.2114 36.5303 16.0005 36 16H30V12C29.9995 11.4697 29.7886 10.9613 29.4136 10.5864C29.0387 10.2114 28.5303 10.0005 28 10H20C19.4697 10.0005 18.9613 10.2114 18.5864 10.5864C18.2114 10.9613 18.0005 11.4697 18 12V16H12C11.4697 16.0005 10.9613 16.2114 10.5864 16.5864C10.2114 16.9613 10.0005 17.4697 10 18V32C10.0005 32.5303 10.2114 33.0387 10.5864 33.4136C10.9613 33.7886 11.4697 33.9995 12 34H25V32ZM20 12H28V16H20V12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKpIsAndProgramsManagement);
export default __webpack_public_path__ + "static/media/KPIsAndProgramsManagement.6fa780a9a27911dac7aa8741550e266e.svg";
export { ForwardRef as ReactComponent };